import type { MaximizedPanel } from './SelectDriversContext';

export const getGridSectionClass = (
  classes: Record<string, string> | undefined,
  maximizedPanel: MaximizedPanel
): string => {
  if (!classes) return '';
  if (maximizedPanel === 'grid') return classes.topGridContainerMaximized;
  if (maximizedPanel === 'map') return classes.topGridContainerHidden;
  return classes.topGridContainer;
};

export const getMapSectionClass = (
  classes: Record<string, string> | undefined,
  maximizedPanel: MaximizedPanel
): string => {
  if (!classes) return '';
  if (maximizedPanel === 'map') return classes.mapContainerMaximized;
  if (maximizedPanel === 'grid') return classes.mapContainerHidden;
  return classes.mapContainer;
};
